import { createContext, useContext } from 'react';
import type { FeatureFlagResolveResult } from '@/shared/data/featureFlags';

type FeatureFlagsContextValue = {
  flags: FeatureFlagResolveResult['flags'] | null;
  loading: boolean;
};

export const FeatureFlagsContext = createContext<FeatureFlagsContextValue | null>(null);

export const useResolvedFeatureFlags = (): FeatureFlagsContextValue =>
  useContext(FeatureFlagsContext) ?? { flags: null, loading: true };
